import { render, staticRenderFns } from "./xfj.vue?vue&type=template&id=ed5745a6&scoped=true"
import script from "./xfj.vue?vue&type=script&lang=js"
export * from "./xfj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5745a6",
  null
  
)

export default component.exports